import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { ErrorSection } from '@/components/sections/error-section';
import { Button } from '@/components/ui/button';
import { useUser } from '@/hooks/use-user';
import { ACCESS_POM_ROLE } from '@/keys';
import { FullWidthConstrainedLayout } from '@/layouts/full-width-constrained-layout';

type AccessGuardProps = { children: ReactElement };

export function AccessGuard({ children }: AccessGuardProps): ReactElement {
  const { user } = useUser();
  const roles = user?.realmRoles || [];
  const { t } = useTranslation('errors');
  const { signoutRedirect } = useAuth();

  return roles.includes(ACCESS_POM_ROLE) ? (
    children
  ) : (
    <FullWidthConstrainedLayout>
      <div className='flex min-h-screen flex-1 items-center justify-center py-24'>
        <ErrorSection
          action={
            <Button
              onClick={() =>
                signoutRedirect({
                  post_logout_redirect_uri: window.location.origin,
                })
              }
            >
              {t('Logout')}
            </Button>
          }
          code={403}
          description={t('You are not authorized to access this app')}
          title={t('Forbidden')}
        />
      </div>
    </FullWidthConstrainedLayout>
  );
}
